import { useState } from "react";
import Layout from "@/components/Layout";
import ReceptionistChat from "@/components/ReceptionistChat";
import { Link2, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Reception() {
  const [copied, setCopied] = useState(false);
  const publicUrl = `${window.location.origin}/book`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(publicUrl);
      setCopied(true);
      toast.success("Public booking link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Could not copy link"); }
  };

  return (
    <Layout title="AI Reception" subtitle="Book callers straight into Cliniko — or share the self-serve link with patients"
      actions={
        <Button variant="outline" onClick={copy} data-testid="copy-booking-link">
          {copied ? <Check className="mr-1.5 h-4 w-4 text-emerald-600" /> : <Link2 className="mr-1.5 h-4 w-4" />}
          {copied ? "Copied" : "Copy patient link"}
        </Button>
      }>
      <div className="mx-auto h-[calc(100vh-13rem)] max-w-3xl">
        <ReceptionistChat channel="internal" greeting="Hi! I can book an appointment into Cliniko. Who's the appointment for and what do they need?" />
      </div>
    </Layout>
  );
}
